<template>
  <div class="d-flex justify-content-between">
    <h1>Variablen</h1>

    <button class="btn" @click="loadVariablen()"><font-awesome-icon icon="rotate" /></button>
  </div>

  <div class="row my-4">
    <div class="col-4">
      <EditVariableModal />
    </div>

    <div class="col-4 my-auto">
      <div class="input-group input-group-sm my-auto">
        <input v-model.trim="searchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
        <span class="input-group-text">
          <font-awesome-icon icon="magnifying-glass" class="p-1" />
        </span>
      </div>
    </div>

    <div v-if="!loading && variablen.length > 0" class="col-4 d-flex align-items-center justify-content-end">
      <div class="dropdown me-2">
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="select-herkunft-button" data-bs-toggle="dropdown" aria-expanded="false">
          Herkunft auswählen...
        </button>
        <div class="dropdown-menu p-0" aria-labelledby="select-herkunft-button">
          <div
            v-for="(table, index) in herkunft.sort((a: any, b: any) => a.key.localeCompare(b.key))"
            :key="index"
            class="dropdown-checkbox px-1 py-2 border-bottom"
          >
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :id="'selected-herkunft-item-' + index" v-model="selectedHerkunft" :value="table" />
              <label class="form-check-label" :for="'selected-herkunft-item-' + index">{{ table.key != '' ? table.key : 'Unbekannt' }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-group" role="group" aria-label="View Section select">
        <button type="button" class="btn btn-outline-secondary" :class="{ active: viewSection === 'list' }" @click="setViewSection('list')">
          <font-awesome-icon icon="list" />
        </button>
        <button type="button" class="btn btn-outline-secondary" :class="{ active: viewSection === 'grouped' }" @click="setViewSection('grouped')">
          <font-awesome-icon icon="layer-group" />
        </button>
      </div>
    </div>
  </div>

  <div v-if="selectedHerkunft.length > 0" class="d-flex justify-content-end mx-1">
    <small class="text-muted">
      Filter: <span v-for="filter in selectedHerkunft" :key="filter" class="me-2">{{ filter.key }} </span>
    </small>
  </div>

  <div v-else-if="errorMsg != ''" class="alert alert-danger mt-5">
    <!-- Es ist ein Fehler beim Laden der Variablen aufgetreten. Bite probieren Sie es später erneut. -->
    {{ errorMsg }}
  </div>

  <div v-if="variablen.length > 0">
    <section v-if="viewSection == 'list'">
      <div class="row mx-0 mb-2 bg-white shadow-sm">
        <div class="col-3 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong class="me-1">Titel</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'titelasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'titeldesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('titelasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'titelasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('titeldesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'titeldesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-2 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong class="me-1">Variable</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'platzhalterasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'platzhalterdesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('platzhalterasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'platzhalterasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('platzhalterdesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'platzhalterdesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-1 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong class="me-1">Herkunft</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'herkunftasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'herkunftdesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('herkunftasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'herkunftasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('herkunftdesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'herkunftdesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-2 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong class="me-1">Feld</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'feldasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'felddesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('feldasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'feldasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('felddesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'felddesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-1 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong class="me-1">Type</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'typeasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'typedesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('typeasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'typeasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('typedesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'typedesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-2 py-2 table-col">
          <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <strong>Gruppe</strong>

            <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'gruppeasc'" class="text-secondary table-sort-icon" />
            <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'gruppedesc'" class="text-secondary table-sort-icon" />

            <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
              <li class="dropdown-item select-sort" @click="sortBy('gruppeasc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'gruppeasc'" />
                  </div>
                  <div class="col">A - Z</div>
                </div>
              </li>
              <li class="dropdown-item select-sort" @click="sortBy('gruppedesc')">
                <div class="row">
                  <div class="col-2">
                    <font-awesome-icon icon="check" v-show="sortByValue == 'gruppedesc'" />
                  </div>
                  <div class="col">Z - A</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-1 py-2">
          <strong class="me-1">Verwendet</strong>
        </div>
      </div>

      <VariableRow v-for="variable in sortedVariablen" :key="variable.id" :variable="variable" />
    </section>

    <section v-else-if="viewSection == 'grouped'">
      <div v-for="(value, key) in groupedItems" :key="key" class="mb-4">
        <h4>{{ key }}</h4>

        <div class="row mx-0 mb-1">
          <div class="col-3 fw-bold px-2 my-auto">Titel</div>
          <div class="col-2 fw-bold px-2 my-auto">Variable</div>
          <div class="col-1 fw-bold px-2 my-auto">Herkunft</div>
          <div class="col-2 fw-bold px-2 my-auto">Feld</div>
          <div class="col-1 fw-bold px-2 my-auto">Typ</div>
          <div class="col-2 fw-bold px-2 my-auto">Gruppe</div>
          <div class="col-1 fw-bold px-2 my-auto">Verwendet</div>
        </div>

        <VariableRow v-for="variable in value" :key="variable.id" :variable="variable" />
      </div>
    </section>
  </div>

  <div v-if="!loading && errorMsg == '' && sortedVariablen.length == 0" class="alert alert-info my-4">Es wurden keine Variablen gefunden.</div>

  <LoadingOverlay v-if="loading" text="... Daten werden geladen ..." />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, ref, onMounted } from 'vue';
  import { useStore } from 'vuex';

  import { ActionTypes as VariablenActionTypes } from '@/store/modules/Variablen/actions';
  import { ActionTypes as VorlageActionTypes } from '@/store/modules/Vorlagen/actions';

  import LoadingOverlay from '@/components/LoadingOverlay.vue';
  import EditVariableModal from '@/components/Vorlagen/EditVariableModal.vue';
  import VariableRow from '@/components/Vorlagen/VariableRow.vue';
  import { GroupedVariablen, Variable } from '@/models/VorlageModels';
  //#endregion

  const store = useStore();

  const loading = computed(
    () =>
      store.getters.status.getVariablenLoading ||
      store.getters.status.deleteVariablenLoading ||
      store.getters.status.getTextbausteineLoading ||
      store.getters.status.createVariablenLoading ||
      store.getters.status.updateVariablenLoading
  );
  const errorMsg = computed(() => store.getters.status.variablenErrorMsg);

  const variablen = computed(() => store.getters.variablen);

  const searchString = ref('');
  const selectedHerkunft = ref<Array<any>>([]);
  const herkunft = [
    { key: 'Keine', value: '' },
    { key: 'Personaldaten', value: 'Personaldaten' },
    { key: 'Vertrag', value: 'Vertrag' },
  ];

  const sortByValue = ref('titelasc');
  function sortBy(param: string) {
    sortByValue.value = param;
  }

  const viewSection = ref('list');
  function setViewSection(section: string) {
    viewSection.value = section;
    sortByValue.value = 'gruppeasc';
    localStorage.setItem('textvariablenViewSection', section);
  }

  const sortedVariablen = computed(() => {
    return variablen.value
      .filter((v: Variable) => (selectedHerkunft.value.length > 0 ? selectedHerkunft.value.map((h) => h.value).includes(v.herkunft) : true))
      .filter((v: Variable) => {
        return (
          v.titel.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v.gruppe.trim().toLowerCase().includes(searchString.value.trim().toLowerCase())
        );
      })
      .sort((a: Variable, b: Variable) => {
        if (sortByValue.value == 'titeldesc' || sortByValue.value == 'titelasc') {
          var titleComparison = a.titel.trim().toLowerCase().localeCompare(b.titel.trim().toLowerCase());
          if (sortByValue.value == 'titeldesc') {
            titleComparison = -1 * titleComparison;
          }

          return titleComparison;
        }

        if (sortByValue.value == 'gruppedesc' || sortByValue.value == 'gruppeasc') {
          var gruppeComparison = a.gruppe.trim().toLowerCase().localeCompare(b.gruppe.trim().toLowerCase());
          if (sortByValue.value == 'gruppedesc') {
            gruppeComparison = -1 * gruppeComparison;
          }

          if (gruppeComparison == 0) {
            var titleComparison = a.titel.trim().toLowerCase().localeCompare(b.titel.trim().toLowerCase());
            return titleComparison;
          }

          return gruppeComparison;
        }

        if (sortByValue.value == 'platzhalterdesc' || sortByValue.value == 'platzhalterasc') {
          var platzhalterComparison = a.platzhalter.trim().toLowerCase().localeCompare(b.platzhalter.trim().toLowerCase());
          if (sortByValue.value == 'platzhalterdesc') {
            platzhalterComparison = -1 * platzhalterComparison;
          }

          return platzhalterComparison;
        }

        if (sortByValue.value == 'herkunftdesc' || sortByValue.value == 'herkunftasc') {
          var herkunftComparison = a.herkunft.trim().toLowerCase().localeCompare(b.herkunft.trim().toLowerCase());
          if (sortByValue.value == 'herkunftdesc') {
            herkunftComparison = -1 * herkunftComparison;
          }

          return herkunftComparison;
        }

        if (sortByValue.value == 'felddesc' || sortByValue.value == 'feldasc') {
          var feldComparison = a.feld.trim().toLowerCase().localeCompare(b.feld.trim().toLowerCase());
          if (sortByValue.value == 'felddesc') {
            feldComparison = -1 * feldComparison;
          }

          return feldComparison;
        }

        if (sortByValue.value == 'typedesc' || sortByValue.value == 'typeasc') {
          const aType = typeConverter(a);
          const bType = typeConverter(b);

          var typeComparison = aType.trim().toLowerCase().localeCompare(bType.trim().toLowerCase());
          if (sortByValue.value == 'typedesc') {
            typeComparison = -1 * typeComparison;
          }

          return typeComparison;
        }

        return 0;
      });
  });

  const groupedItems = computed<GroupedVariablen>(() => {
    const noGroup: Variable[] = [];

    const data = sortedVariablen.value.reduce((groups: GroupedVariablen, variable: Variable) => {
      if (!variable.gruppe) {
        noGroup.push(variable);
      } else {
        const groupsList = variable.gruppe.split(';');

        for (let group of groupsList) {
          group = group.trim();

          if (group === '') {
            continue;
          }

          const existingGroup = groups[group];

          if (existingGroup) {
            existingGroup.push(variable);
          } else {
            groups[group] = [variable];
          }
        }
      }
      return groups;
    }, {});

    // Sort keys alphabetically
    const sortedData: GroupedVariablen = {};
    Object.keys(data)
      .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
      .forEach((key) => {
        sortedData[key] = data[key];
      });

    if (noGroup.length > 0) {
      sortedData['Keine Gruppe'] = noGroup;
    }

    return sortedData;
  });

  function typeConverter(variable: Variable) {
    if (variable.type === 'date') {
      return 'Datum';
    } else if (variable.type === 'text') {
      if (variable.validationType === 'text') {
        return 'Text';
      } else if (variable.validationType === 'float') {
        return 'Zahl';
      } else if (variable.validationType === 'currency') {
        return 'Währung';
      } else if (variable.validationType === 'usersignature') {
        return 'Benutzersignatur';
      } else {
        return 'Unbekannt';
      }
    } else {
      return 'Unbekannt';
    }
  }

  function loadVariablen() {
    store.dispatch(VariablenActionTypes.GetVariablen, undefined);

    if (store.getters.textbausteine.length == 0) {
      store.dispatch(VorlageActionTypes.GetTextbausteine, undefined);
    }
  }

  onMounted(() => {
    loadVariablen();

    viewSection.value = localStorage.getItem('textvariablenViewSection') || 'list';
  });
</script>

<style scoped>
  .table-col:hover {
    background: rgb(216, 217, 222);
    cursor: pointer;
  }

  .table-sort-icon {
    font-size: 0.7em;
  }

  .select-sort:hover {
    cursor: pointer;
  }
</style>
